<app-web-loader *ngIf="isLoader"></app-web-loader>

<div id="main-venture-view" *ngIf="ventureInfo != null">
    <div class="form-group">
        <label class="label-bold m-0">Venture / Project Name</label>
        <label class="form-control label-data-info">{{ ventureInfo?.ProjectOrVentureName }}</label>
    </div>
    <div class="form-group">
        <label class="label-bold m-0">Developed By</label>
        <label class="form-control label-data-info">{{ ventureInfo?.Developer_Name }}</label>
    </div>
    <div class="form-group">
        <label class="label-bold m-0">Area Name</label>
        <label class="form-control label-data-info">{{ ventureInfo?.AreaName }}</label>
    </div>
    <div class="form-group">
        <label class="label-bold m-0">Amenities</label>
        <label class="form-control label-data-info">{{ ventureInfo?.AREAS_JSON }}</label>
    </div>

    <table class="table table-striped table-bordered">
        <tr>
            <td class="label-bold">Types Of Units</td>
            <td class="label-bold">Unit Measures</td>
        </tr>
        <tr>
            <td>{{ ventureInfo?.TypesOfUnits }}</td>
            <td>{{ ventureInfo?.UnitMeasures }}</td>
        </tr>
        <tr>
            <td class="label-bold">Nn Of Units / Plots</td>
            <td class="label-bold">No Of Floors</td>
        </tr>
        <tr>
            <td>{{ ventureInfo?.NumberOfUnitsOrPlots }}</td>
            <td>{{ ventureInfo?.NumberOfFloors }}</td>
        </tr>
        <tr>
            <td class="label-bold">Project Status</td>
            <td class="label-bold">Pricing Details</td>
        </tr>
        <tr>
            <td>{{ ventureInfo?.ProjectStatus }}</td>
            <td>{{ ventureInfo?.PricingDetails }}</td>
        </tr>
        <tr>
            <td class="label-bold">Launch Date</td>
            <td class="label-bold">Completion Date</td>
        </tr>
        <tr>
            <td>{{ ventureInfo?.LaunchDate }}</td>
            <td>{{ ventureInfo?.CompletionDate }}</td>
        </tr>
    </table>

    <p class="venture-overview" [innerHtml]="ventureInfo?.Overview"></p>
    
</div>